import { cn } from "@/lib/utils";

export default function Buttons({
    className,
    children,
}: {
    className?: string;
    children: React.ReactNode;
}) {
    return <div className={cn("flex items-center gap-4 w-full", className)}>{children}</div>;
}
